<template>
    <div id="app">
        <div>
            <SignInPC v-if="isPC" />
            <SignInH5 v-else />
        </div>
    </div>
</template>
<script>
import { enableAppShare } from '../../../common/js/APP/share';
import SignInPC from '../components/SignInPCNew';
import SignInH5 from '../components/SignInH5New';

import loadScript from '../../../uitl/load-script';
import { fetchQueryFNNew } from '../../../service/api'
import { getCookie, setCookie } from '../../../uitl/getParam.js';
export default {
    components: {
        SignInPC,
        SignInH5,
    },
    data() {
      return {
        canvasUrl: 'https://www.lgstatic.com/mds-icon-fed/kaiwu/frontend/share.jpeg' ,
        isBView:'A',//A版      B版 
      };
    },
    mounted() {
      loadScript('https://res.wx.qq.com/open/js/jweixin-1.3.2.js');
      enableAppShare({
        title: '如何告别低薪，多且杂的前端工作？',
        desc: '前端必看：一套阿里P5-P7前端开发技能',
        imgUrl: this.canvasUrl,
      });
      // this.getPageFn()
    },
    methods: {
      getPageFn() {  
          const page_key = 'FE_ENHANCEMENT';
          if (!this.isApp) {
              let page = JSON.parse(getCookie(page_key));
              if (!page) {
                  page = {}
                  page.pageType = Math.ceil(Math.random() * 2)
                  setCookie(page_key, JSON.stringify(page))
              } 
              this.isBView = page.pageType == 2 ? 'B' : 'A';
              return 
          } 
          let params = {
              pageMark: page_key,//AI 
          }
          fetchQueryFNNew(params).then(res => {
              if(res.state == 1) {
                  if(res.content) { //命中页面 不返回值 
                      this.isBView = 'B';
                  } else { //未命中 走a版
                      this.isBView = 'A'
                  } 
              } else {
                  this.isBView = 'A'  //默认a版  报错a版
              }
          }).catch(error => {
              this.isBView = 'A'  //默认a版  报错a版
          });
      }, 
    },
};
</script>
<style>
 body {
        -webkit-overflow-scrolling: touch;
    }
  #app {
    height: 100%;
    overflow-x: hidden;
  }

  #appHeader {
    position: fixed;
    width: 100%;
    z-index: 10;
    left: 0;
    top: 0;
  }

  .single-line {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .lg_tbar_r {
    font-size: 14PX;
  }

  .scale-1px {
    position: relative;
    border: none;
  }

  .scale-1px:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #000;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 200%;
    height: 200%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: left top;
    transform-origin: left top;
  }

  .clearfix:after {
    content: '';
    height: 0;
    display: block;
    clear: both;
  }
</style>
